const  data = {
    "Home.message": "It's a beautiful day outside.",
    "home.beauty_advisor": "Beauty Advisor",
    "home.virtual_mirror": "Virtual Mirror",
    "home.lens_find": "Find the Best Lens for me.",
    "home.lens_continue": "Tap to continue",
    "home.quiz_find": "Find my persona",
    "home.logout": "Logout",
    "home.let_us_find": "Let us find the",
    "home.look_for_you": "look for you",
    "home.try_a_lens": "Try a lens",
    "home.color": "color",
    "without_quiz.lens_color": "Try a lens color",
    "without_quiz.access_cam": "Define Would Like to Access the Camera",
    "without_quiz.access_cam_sub_text": "Used for Live Try on",
    "without_image.img_confirm": "Are you sure you want to use this image?",
    "without_image.Allow" : "Don't Allow",
    "without_image.OK":"OK",
    "dba.find_look" : "Let us find the look for you",
    "dba.about_urself" : "Tell us more about yourself",
    "dba.trydba" : "Try the DBA App",
    "dba.next" : "Next",
    "dba.Currently wearing:" : "Currently wearing:",
    "quiz.skin_color" : "What is your skin tone color?",
    "quiz.hair_Color" : "What is your hair color?",
    "menu.home" : "Home",
    "menu.bye" : "Bye",
    "menu.share" : "Share",
    "menu.save" : "Save",
    "menu.trail" : "Free trial",
    "menu.find" : "Find Doctor",
    "menu.product" : "Product Info",
    "lens.bright" : "Radiant Bright™",
    "lens.shine" : "Natural Shine™",
    "lens.charm" : "Radiant Charm™",
    "lens.chic" : "Radiant Chic™",
    "lens.sweet" : "Radiant Sweet™",
    "lens.vivid" : "Vivid Style",
    "lens.accent" : "Accent Style",
    "footer.care"  :"About Lens Care",
    "footer.products" : "About Products",
    "footer.legal": "Legal Notice",
    "footer.acuvue": 'About Acuvue<sup class="text-small">®</sup> Define™',
    "footer.contact": "Contact Us",
    "footer.privacy": "Privacy Policy",
    "footer.label": "About",
    "footer.makeup" : "Makeup Tutorial",
    "login.email" : "E-mail",
    "login.password": "Password",
    "login.submit" : "Submit",
    "nav.welcome_guest": "Welcome Guest",
    "vm.currently_wearing": "Currently Wearing",
    "vm.rec_variant": "Recommended Variant",
    "product_info.about": "About Our Lenses",
    "lens.now": "Now",
    "tabs.lenses": "Lenses",
    "tabs.looks": "Looks",
    "tabs.makeup": "Makeup",
    "tabs.insertion": "Insertion",
    "tabs.removal": "Removal",
    "tooltip.home": "Home",
    "tooltip.ba": "Beauty Advisor",
    "tooltip.care": "Lens Care",
    "tooltip.more": "More Options",
    "tooltip.buy": "Buy",
    "tooltip.share": "Share",
    "tooltip.trial": "DEFINE® Promotions",
    "tooltip.ecp": "Find ECP",
    "tooltip.logout": "Logout",
    "tooltip.vm": "Virtual Try On",
    "modal.share": "Share",
    "modal.buy": "Buy",
    "modal.free_trial": "Free Trial",
    "modal.shop_now": "Shop Now",
    "modal.go": "Go",
    "looks.downloadPdf": "Download Tutorial",
    "guides.how_to_put_on_lens": "How to put on contact lens in 4 easy steps",
    "guides.how_to_remove_lens": "How to remove your contacts in 4 easy steps",
    "looks.you_have_selected": "You have selected: ",
    "tutorials.or": "OR",
    "tutorials.scan": "Scan QR code to download",
    "tutorials.product_unavailable": "This product is currently unavailable in this market.",
    "tutorials.look": "Look ",
    "products.disclaimer_header": "References/ Disclaimer",
    "product.browser-alert": "Best experienced in a setting with bright and natural lighting.<br/>This feature is not supported on Internet Explorer.",
    "tutorials.purchase": "Buy online",
    "tutorials.lens": "Lens",
    "looks.best_suited": "look is best suited with",
    "looks.product_unavailable": "Not Available",
    "looks.you_have_chosen": "You have chosen:",
    "looks.with_lens": "With Lens:",
    "looks.with_looks": "With Looks:",
    "permissions.allow_look_removal": "This action would remove applied look",
    "permissions.allow_makeup_removal": "This action would remove applied makeup",
    "permissions.allow_look_removal_sub_text": "Do you want to proceed?",
    "tabs.pls_select_look": "Please select a look",
    "tabs.pls_select_lens": "Please select a lens",
    "tabs.pls_select_makeup_category": "Please select a makeup category",
    'button.value_try_the': 'Try the',
    'button.heading_try_the': 'Lens',
    'button.value_find_your': 'Find Your',
    'button.heading_find_your': 'Persona',
    'button.value_price': 'RM60 Welcome',
    'button.heading_price': 'Reward',
    'tabs.fresh_lenses': 'Define Fresh',
    'tabs.classic_lenses': 'Define Classic',
    'tabs.makeup': 'Make Up Looks'
  }
  export default data;
